// import { isNil } from '@/utils/helpers'
import useLocalStorage from '@/utils/localStorage'
import { useSearchParams } from 'next/navigation'
import { FunctionComponent, useContext, createContext, useEffect } from 'react'

const themeContext = createContext<ThemeContext>({
  theme: 'light',
  setTheme: (theme) => {
    throw new Error('setTheme not implemented')
  }
})

export const ThemeProvider: FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useLocalStorage<AppTheme>('@mobicom_theme', 'light')
  // const prefersDarkMode = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

  // let currentTheme = prefersDarkMode ? 'dark' : (!isNil(theme) && (theme === 'light' || theme === 'dark')) ? theme : 'light'

  // let currentTheme = (!isNil(theme) && (theme === 'light' || theme === 'dark')) ? theme : 'light'

  const mode = useSearchParams().get('theme')

  useEffect(() => {
    if (mode !== null && (mode === 'light' || mode === 'dark')) {
      setTheme(mode)
      document.body.classList.replace(theme, mode)
      // document.body.classList.add(mode)
    } else {
      setTheme('light')
    }
  }, [mode])

  useEffect(() => {
    if (theme === 'light' || theme === 'dark') {
      document.body.classList.add(theme)
    }
  }, [theme])

  return (
    <themeContext.Provider
      value={{
        theme,
        setTheme
      }}
    >
      {children}
    </themeContext.Provider>
  )
}

export const useTheme = (): ThemeContext => {
  return useContext(themeContext)
}

export interface ThemeContext {
  theme: AppTheme
  setTheme: (theme: AppTheme) => void
}

export type AppTheme = 'light' | 'dark'

// export interface Language {
//   locale: Locale
//   name: string
//   icon: string
// }
